import React from 'react';
import {
    Container,
    Grid,
    Typography,
    makeStyles
} from '@material-ui/core';
import Page from 'components/Page';
import { useTranslation } from "react-i18next";
import ServiceTable from './ServiceTable';

const useStyles = makeStyles((theme) => ({
    root: {
    }
}));

export default function ServiceListView() {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Page
            className={classes.root}
            title={t('navbar.services')}
        >
            <Container maxWidth={false}>
                <Typography variant="h1" gutterBottom >
                    {t('navbar.services')}
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <ServiceTable/>
                    </Grid>
                </Grid>
            </Container>
        </Page>
    );
}